'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const ScheduleGraphDirectiveController=require('../../../../dist-es6/client/directives/scheduleGraphDirective/scheduleGraphDirective').DirectiveController;
const fpe=require('../../../../dist-es6/shared/extensions/fatiguePointExtensions');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');let

TimelineGraphDirective=function(_BaseControllerBacked){_inherits(TimelineGraphDirective,_BaseControllerBacked);function TimelineGraphDirective(){_classCallCheck(this,TimelineGraphDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TimelineGraphDirective,[{key:'templateUrl',get:function()
{
return'/templates/directives/timelineGraphDirective/timelineGraphTemplate';
}},{key:'objectBindings',get:function()

{
return[
'interval',
'duties',
'trips',
'sleep',
'sleepPromotingIntervals',
'timezone',
'fatigue',
'incidents',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'fatigueThreshold',
'fatigueThresholds',
'dutyLabelFormatter',
'tripLabelFormatter',
'sleepLabelFormatter',
'sleepPromotingLabelFormatter'];

}},{key:'textBindings',get:function()

{
return[
'useReportStyle'];

}},{key:'controller',get:function()

{
return TimelineGraphDirectiveController;
}}]);return TimelineGraphDirective}(BaseControllerBackedDirective);let


TimelineGraphDirectiveController=function(_ScheduleGraphDirecti){_inherits(TimelineGraphDirectiveController,_ScheduleGraphDirecti);
function TimelineGraphDirectiveController(){_classCallCheck(this,TimelineGraphDirectiveController);var _this2=_possibleConstructorReturn(this,
_ScheduleGraphDirecti.call(this));

_this2.axisLabelMargins={
top:20,
right:0,
bottom:0,
left:_this2.useReportStyle?
56:
82};


_this2._dailyThresholds=_this2._getDailyThresholds();

_this2._alertRanges=_this2._getAlertRangesFromDailyThresholds(_this2._dailyThresholds,_this2.duties.concat(_this2.forecastDutyInterval?[_this2.forecastDutyInterval]:[]));
_this2._tripAlertRanges=_this2._getAlertRangesFromDailyThresholds(_this2._dailyThresholds,_this2.trips);

_this2.alertingForecastedDutyIntervals=_.exists(_this2.forecastDutyInterval)?
TimeInterval.compress(_.compact(_this2._alertRanges.At.concat(_this2._alertRanges.Above).map(function(i){return _this2.forecastDutyInterval.intersection(i)}))):
[];


_this2.tripRowHeight=_this2.useReportStyle?30:60;
_this2.tripTopY=_this2.useReportStyle?4:0;
_this2.tripIntervalVerticalMargin=_this2.useReportStyle?0:4;
_this2.dutyVerticalMargin=_this2.useReportStyle?5:0;
_this2.overThresholdStrokeWidth=2.5;
_this2.underThresholdStrokeWidth=2.5;
_this2.dutyTopMargin=_this2.useReportStyle?_this2.tripRowHeight+_this2.dutyVerticalMargin:_this2.tripRowHeight;


const bottomOfSleepAndDuties=235;
const sleepPromotingHeight=_this2.useReportStyle?7:12;
_this2.sleepPromotingHeight=_this2.useReportStyle?bottomOfSleepAndDuties:sleepPromotingHeight;
_this2.sleepPromotingTopY=_this2.useReportStyle?bottomOfSleepAndDuties-sleepPromotingHeight:void 0;
_this2.sleepTopY=_this2.dutyTopMargin;
_this2.sleepVerticalMargin=_this2.dutyVerticalMargin+sleepPromotingHeight+1;return _this2;
}TimelineGraphDirectiveController.prototype.

_getDailyThresholds=function _getDailyThresholds(){var _this3=this;
const range=CalendarRange.fromExpandedTimeInterval(this.interval,this.timezone);
const daysInGraph=range.asDailyTimeIntervals({timezone:this.timezone,abut:!0});

if(this.fatigueThresholds.length!==daysInGraph.length){
throw new Error('day counts do not match, what\'s up with that?');
}

return daysInGraph.map(function(dayInterval,i){return{
dayInterval:dayInterval,
effectiveThreshold:_this3.fatigueThresholds[i]}});

};TimelineGraphDirectiveController.prototype.

_getAlertRangesFromDailyThresholds=function _getAlertRangesFromDailyThresholds(dailyThresholds,intervals){
const alertRanges={
At:[],
Above:[],
Below:[],
NotApplicable:[]};


for(const _ref of dailyThresholds){const{dayInterval:dayInterval,effectiveThreshold:effectiveThreshold}=_ref;
const{At:At,Above:Above,Below:Below,NotApplicable:NotApplicable}=fpe(this.fatigue).getAlertRangesOverlapping(effectiveThreshold,TimeInterval.clip(intervals).to(dayInterval));
_.pushMany(alertRanges.At,At);
_.pushMany(alertRanges.Above,Above);
_.pushMany(alertRanges.Below,Below);
_.pushMany(alertRanges.NotApplicable,NotApplicable);
}

return{
At:TimeInterval.compress(alertRanges.At),
Above:TimeInterval.compress(alertRanges.Above),
Below:TimeInterval.compress(alertRanges.Below),
NotApplicable:TimeInterval.compress(alertRanges.NotApplicable)};

};return TimelineGraphDirectiveController}(ScheduleGraphDirectiveController);


module.exports=TimelineGraphDirective;
//# sourceMappingURL=timelineGraphDirective.js.map
